//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false
        };
    },

    computed: {
        avatar () {
            return this.$store.getters.avatar;
        },
        giftName () {
            let gift = this.$store.getters.getUserGiftByWeek(2);

            if (gift && gift.name === 'w2d5surgeon') {
                return this.$lang.get('w2d5.offboarding.xray');
            } else if (gift && gift.name === 'w2d5medtech') {
                return this.$lang.get('w2d5.offboarding.computer');
            } else if (gift && gift.name === 'w2d5roboter') {
                return this.$lang.get('w2d5.offboarding.cat');
            }

            return '';
        }
    }
};
